import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

// Cargar la app completa en segundo plano y, cuando esté lista, reemplazar el splash inline de index.html
const bootstrap = () => {
	import('./AppRoot').then(({ default: AppRoot }) => {
		root.render(<AppRoot />);
	});
};

if (typeof window.requestIdleCallback === 'function') {
	window.requestIdleCallback(bootstrap, { timeout: 1 });
} else {
	setTimeout(bootstrap, 0);
}